<div class="wrapper">
  @if (label.length > 0) {
  <span>{{ label() }}</span>
  }

  <div
    class="input-icons"
    [ngClass]="{
      'with-icon': iconName(),
      'has-password-toggle': showPasswordToggle() && type() === 'password'
    }"
  >
    @if (iconName() && iconSize) {
    <div class="icon-wrapper">
      <ng-icon
        class="icon"
        [name]="iconName()"
        [size]="iconSize.toString()"
        [color]="iconColor()"
      ></ng-icon>
    </div>
    }

    @if (type() === 'textarea') {
    <textarea
      [name]="name()"
      class="input input-{{ size() }} {{ margin() }}"
      [ngClass]="{
        'error-outline': isError(),
        'disabled': disabled(),
      }"
      [value]="value"
      [disabled]="disabled()"
      [rows]="textAreaRows()"
      [cols]="textAreaCols()"
      placeholder="{{ placeholder() }}"
      (input)="onInputChange($event)"
      (blur)="onBlur()"
    ></textarea>
    } @else {
    <input
      [type]="resolvedType"
      [name]="name()"
      class="input input-{{ size() }} {{ margin() }}"
      [ngClass]="{
        'error-outline': isError(),
        'disabled': disabled(),
      }"
      [value]="value"
      [disabled]="disabled()"
      placeholder="{{ placeholder() }}"
      (input)="onInputChange($event)"
      (blur)="onBlur()"
    />

    @if (showPasswordToggle() && type() === 'password') {
    <button
      type="button"
      class="password-toggle"
      [disabled]="disabled()"
      [attr.aria-label]="passwordVisible ? 'Hide password' : 'Show password'"
      [attr.aria-pressed]="passwordVisible"
      (click)="togglePasswordVisibility()"
    >
      <svg
        class="password-toggle-icon"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
        <circle cx="12" cy="12" r="3" />
        @if (passwordVisible) {
        <path class="password-toggle-slash" d="M3 3 21 21" />
        }
      </svg>
    </button>
    }
    }
  </div>
</div>
